<script setup lang="ts">
import moment from 'moment';


const nowTime = ref(moment());

onMounted(() => {

  setInterval(() => {
   nowTime.value = moment();
  }, 1000)

})


</script>

<template>
  <div class="toc-design-header">
    <div class="title">

    </div>
    <div class="info-wrapper">
      <div class="now-date">
        {{ nowTime.format('YYYY-MM-DD HH:mm:ss') }}
      </div>
      <div class="pointer-section">
        <div class="alarm-wrapper">
          <img src="@/assets/images/renewal/notification.svg"></img>
          <span class="noise">1</span>
        </div>
        <div class="divider"></div>
        <div class="user-info">
          <div class="user-info-icon">

          </div>
          <div class="caret">
            
          </div>
        </div>
      </div>
 
    </div>
  </div>
</template>


<style lang="scss" scoped>
.toc-design-header{
  color: #F5F5F5;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  .info-wrapper{
    height: 100%;
    display: flex;
    align-items: center;
    width: 25%;
    justify-content: flex-end;
    .now-date{
      font-family: "NanumSquare Neo";
      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: normal;
      margin-right: 10px;
      width: 45%;
      text-align: left;
    }

    .pointer-section{
      display: flex;
      width: 40%;
      height: 100%;
      justify-content: space-around;
      align-items: center;
      .alarm-wrapper{
        border-radius: 10px;
        border: 1px solid #E4E4E7;
        background: #FFF;
        padding: 5px;
        position: relative;
        cursor: pointer;
        img{
          width: 30px;
          height: 30px;
        }
        .noise{
          position: absolute;
          top: 1px;
          right: 2px;
          width: 20px;
          height: 20px;
          background-color: #f76829;
          border-radius: 100%;
          color: #FFF;
          text-align: center;
          font-family: "Plus Jakarta Sans";
          font-size: 10px;
          font-style: normal;
          font-weight: 700;
          line-height: 18px; /* 180% */
          align-content: center;
        }
      }
      .divider{
        background: #E4E4E7;
        width: 1px;
        height: 100%;
      }
      .user-info{
        cursor: pointer;
        display: flex;
        align-items: center;
        .user-info-icon{
          background-color: #d9d9d9;
          width: 40px;
          height: 40px;
          border-radius: 100%;
        }
        .caret{
          width: 30px;
          height: 30px;
          background: url("@/assets/images/renewal/user-caret.svg") no-repeat scroll center;
        }
      }
    }
    
  }
}
</style>